// @flow
import BluebirdPromise from 'bluebird';

import * as r from './resources';
import { get } from './http';

import type { Scan } from 'modules/scan';
import type { Dispatch, GetState } from '~/store';

export type ScanRequestParams = $ReadOnly<{|
  scan: Scan,
  customerNumber: string,
  // catalogKey is not used by the actual API request, but is
  // used in the corresponding reducers so it needs to be
  // passed in here.
  catalogKey: string,
|}>;

export const productsByScan = (
  params: ScanRequestParams,
  // this is a dirty hack because Resource expects a string here
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  get(r.productsForScan, (params: any));

export const keysByBarcode = (
  params: ScanRequestParams,
  // this is a dirty hack because Resource expects a string here
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  get(r.barcodesForScan, (params: any));
